import React from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const LoadingState: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="space-y-6">
			<div className="flex items-center justify-center h-32">
				<CircularProgress />
				<span className="ml-3 text-gray-600">{t("feature.courseBuilder.labs.createLab.loadingEquipmentData")}</span>
			</div>
		</div>
	);
};

export default LoadingState;
